var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "as-order-dialog",
      attrs: {
        visible: _vm.visible,
        title: "请赶快处理该条售后申请吧~",
        width: "360px",
        center: "",
        "append-to-body": true,
        "before-close": _vm.setOrderFlag,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("i", {
            staticClass: "el-icon-close",
            on: {
              click: function($event) {
                _vm.visible = false
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "as-order-title" }, [
            _vm._v("请赶快处理该条售后申请吧~")
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { type: "primary" },
              on: { click: _vm.handleConfirm }
            },
            [_vm._v("我已收到货，立即去确认")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-default", on: { click: _vm.handleCreate } },
            [_vm._v("\n      未收到货/货物有异常，去建工单\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bd99a9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd99a9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pendingOrder/asOrderDialog.vue
// module id = null
// module chunks = 